import { ActionCreatorWithoutPayload, createAction } from "@reduxjs/toolkit";

/**
 *
 */
export namespace SignOutAction {

  export const signOut: ActionCreatorWithoutPayload = createAction('SIGN_OUT');
}